import React from 'react';
import { useNavigate } from 'react-router-dom';
import apiHooks from '../../../hooks/apiHooks';
import ListDataPage from '../../../components/pages/ListDataPage';
import dayjs from 'dayjs';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import ActionDropdownItems from 'components/common/ActionDropdownItems';

interface ActionItem {
  eventKey: string;
  label: string;
  type: 'function' | 'redirect'; // Ensure type is restricted
  callback?: () => void;
  url?: string;
  className?: string;
  divider?: boolean;
}

const AllCategories = () => {
  const navigate = useNavigate(); // React Router hook for navigation

  // Function to return properly typed actions for each row
  const getActions = (category_id: string): ActionItem[] => [
    {
      eventKey: '2',
      label: 'Edit',
      type: 'function',
      callback: () =>
        navigate(`/inventory/products/edit-category/${category_id}`)
    },
    {
      eventKey: '3',
      label: 'Remove',
      type: 'function',
      // callback: () => deleteSalesService(service_id),
      className: 'text-danger'
    }
  ];

  const columns = [
    { accessorKey: 'id', header: 'Category ID' },
    { accessorKey: 'name', header: 'Category Name' },
    { accessorKey: 'description', header: 'Description' },
    { accessorKey: 'status', header: 'status' },
    {
      accessorKey: 'created_at',
      header: 'Created At',
      cell: ({ row }: { row: any }) => (
        <span>
          {dayjs(row.original.created_at).format('DD/MM/YYYY HH:mm:ss')}
        </span>
      )
    },
    {
      id: 'action',
      header: 'Actions',
      cell: ({ row }: { row: any }) => (
        <RevealDropdownTrigger style={{ zIndex: '999' }}>
          <RevealDropdown>
            <ActionDropdownItems actions={getActions(row.original.id)} />
          </RevealDropdown>
        </RevealDropdownTrigger>
      ),
      meta: {
        headerProps: { style: { width: '7%' } },
        cellProps: { className: 'text-center' }
      }
    }
  ];

  return (
    <ListDataPage
      apiHook={apiHooks.useCategoryHook}
      entityName="All Categories"
      columns={columns}
    />
  );
};

export default AllCategories;
